// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentHistoryModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentHistoryModel.attributeTypeMap;
    }
}
ExtEnrollmentHistoryModel.discriminator = undefined;
ExtEnrollmentHistoryModel.additionalProperties = false;
ExtEnrollmentHistoryModel.attributeTypeMap = [
    {
        "name": "enrollmentId",
        "baseName": "enrollmentId",
        "type": "string"
    },
    {
        "name": "claimEligibilityDate",
        "baseName": "claimEligibilityDate",
        "type": "Date"
    },
    {
        "name": "enrollmentStartDate",
        "baseName": "enrollmentStartDate",
        "type": "Date"
    },
    {
        "name": "enrollmentEndDate",
        "baseName": "enrollmentEndDate",
        "type": "Date"
    },
    {
        "name": "enrollmentStatus",
        "baseName": "enrollmentStatus",
        "type": "string"
    },
    {
        "name": "totalBenefitAmount",
        "baseName": "totalBenefitAmount",
        "type": "number"
    },
    {
        "name": "remainingBenefitAmount",
        "baseName": "remainingBenefitAmount",
        "type": "number"
    },
    {
        "name": "totalPaidAmount",
        "baseName": "totalPaidAmount",
        "type": "number"
    },
];
//# sourceMappingURL=extEnrollmentHistoryModel.js.map